import React, { useState, useEffect } from "react";
import { getTrend, updateTrend } from "../api_services/TrendTracker";

export const TrendTracker = () => {
    const [trend, setTrend] = useState(0);
    const [trendLoading, setTrendLoading] = useState(false);

    useEffect(() => {
        const initializeTrend = async () => {
            setTrendLoading(true);
            try {
                const response = await getTrend();
                setTrend(response.number_of_directions || 0);
            } catch (error) {
                console.error("Failed to fetch trend:", error);
            } finally {
                setTrendLoading(false);
            }
        };

        initializeTrend();
    }, []);

    const onChangeTrend = async (newTrend) => {
        const numericTrend = parseFloat(newTrend) || 0;
        setTrendLoading(true);
        try {
            setTrend(numericTrend);
            await updateTrend(numericTrend);
        } catch (error) {
            console.error("Error updating trend:", error);
        } finally {
            setTrendLoading(false);
        }
    };

    return (
        <div className="w-full sm:w-auto flex gap-4 items-center">
            <span className="bg-[#02006c] px-4 py-2 rounded-lg text-white">TrendTracker</span>
            <input
                type="number"
                placeholder="Enter trend"
                value={trend === 0 ? '' : trend}
                onChange={(e) => onChangeTrend(e.target.value)}
                className="px-4 py-2 border text-white bg-[#010057] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-32"
            />
            {trendLoading && (
                <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" fill="currentColor"/>
                    <path className="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                </svg>
            )}
        </div>
    );
};
